
import config from "@/config"
import http from "@/utils/request"

export default {
	hlPsb: {
		url: `${config.HNYJ_URL}/api/v1/hlPsb`,
		name: "公安队伍对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlFireControl: {
		url: `${config.HNYJ_URL}/api/v1/hlFireControl`,
		name: "防火指挥机构对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlRescue: {
		url: `${config.HNYJ_URL}/api/v1/hlRescue`,
		name: "其他应急救援力量对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlEmergencyCrew: {
		url: `${config.HNYJ_URL}/api/v1/hlEmergencyCrew`,
		name: "专业抢修队对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlMedical: {
		url: `${config.HNYJ_URL}/api/v1/hlMedical`,
		name: "医疗卫生对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlEmergencyManagement: {
		url: `${config.HNYJ_URL}/api/v1/hlEmergencyManagement`,
		name: "应急管理局对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlFireBrigade: {
		url: `${config.HNYJ_URL}/api/v1/hlFireBrigade`,
		name: "消防队伍对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	hlRescuePlan: {
		url: `${config.HNYJ_URL}/api/v1/hlRescuePlan`,
		name: "救援预案对象功能接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	emergencyMaterial: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/emergencyMaterial`,
		name: "应急物资储备中心接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	emergencyShelter: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/emergencyShelter`,
		name: "应急避难场所接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	fireInspectionStation: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/fireInspectionStation`,
		name: "防火检查站接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	forestFarm: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/forestFarm`,
		name: "林场接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	forestPark: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/forestPark`,
		name: "森林公园接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	natureReserve: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/natureReserve`,
		name: "自然保护区接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	keyProtectionTarget: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/keyProtectionTarget`,
		name: "重点防护目标接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	majorHazardSource: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/majorHazardSource`,
		name: "重大危险源接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	reservoir: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/reservoir`,
		name: "新增水库取水点",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	adminevent: {
		url: `${config.HNYJ_URL}/api/v1/admin/event`,
		name: "事件接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	emergencyMaterialpage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/emergencyMaterial/page`,
		name: "查询应急物资储备中心列表",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	emergencyShelterpage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/emergencyShelter/page`,
		name: "分页查询应急避难场所",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	fireInspectionStationPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/fireInspectionStation/page`,
		name: "分页查询防火检查站",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	forestFarmPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/forestFarm/page`,
		name: "分页查询林场",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	forestParkPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/forestPark/page`,
		name: "分页查询森林公园",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	natureReservePage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/natureReserve/page`,
		name: "分页查询自然保护区",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	reservoirPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/reservoir/page`,
		name: "分页查询水库取水点",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	keyProtectionTargetPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/keyProtectionTarget/page`,
		name: "分页查询重点防护目标",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	majorHazardSourcePage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/majorHazardSource/page`,
		name: "分页查询重大危险源",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	eventPage: {
		url: `${config.HNYJ_URL}/api/v1/admin/event/page`,
		name: "分页查询事件",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	eventList: {
		url: `${config.HNYJ_URL}/api/v1/admin/event/list`,
		name: "查询事件列表",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	hlEventDynamic: {
		url: `${config.HNYJ_URL}/api/v1/hlEventDynamic`,
		name: "事件动态对象功能接口",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	/**
	 * 事件救援预案任务接口
	 * @author Zhao Wang
	 */
	eventRescuePlanTask: {
		url: `${config.HNYJ_URL}/api/v1/admin/event/rescuePlanTask`,
		name: "事件救援预案任务接口",
		put: async function (data) {
			return await http.put(this.url, data);
		}
	},
	/**
	 * 事件救援预案任务执行记录接口
	 * @author Zhao Wang
	 */
	rescuePlanTaskRecord: {
		url: `${config.HNYJ_URL}/api/v1/admin/event/rescuePlanTask/record`,
		name: "事件救援预案任务执行记录接口",
		get: async function (data) {
			return await http.get(this.url + '/list', data);
		},
		post: async function (data) {
			return await http.post(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},


	citybyId: {
		url: `${config.HNYJ_URL}/api/v1/cities/byId`,
		name: "查询所有市区",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	citiesId: {
		url: `${config.HNYJ_URL}/api/v1/cities`,
		name: "根据市区ID查询所有县区",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	resource: {
		url: `${config.HNYJ_URL}/api/v1/appfly/event/resource`,
		name: "资源集合",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},
	// 高压线接口
	highVoltageLine: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/highVoltageLine`,
		name: "高压线表接口",
		post: async function (data) {
			return await http.post(this.url, data);
		},
		put: async function (data) {
			return await http.put(this.url, data);
		},
		get: async function (data) {
			return await http.get(this.url, data);
		},
		delete: async function (data) {
			return await http.delete(this.url + data);
		}
	},
	highVoltageLinePage: {
		url: `${config.HNYJ_URL}/api/v1/admin/information/highVoltageLine/page`,
		name: "分页查询高压线",
		get: async function (data) {
			return await http.get(this.url, data);
		}
	},


}


